import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import styled from 'styled-components';
var ProgressBarRoot = styled.div.withConfig({
  displayName: "ProgressBar__ProgressBarRoot",
  componentId: "sc-1v2uqr7-0"
})(["position:fixed;display:block;height:5px;width:100vw;background-color:#f8f8f8;top:0;left:0;z-index:20;.inner{height:100%;background-color:", ";transition:width 0.1s ease-out;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.primaryColor;
});

var ProgressBar =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ProgressBar, _Component);

  function ProgressBar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      percentage: 0
    };

    _this.updatePercentage = function () {
      return requestAnimationFrame(function () {
        var _window = window,
            scrollY = _window.scrollY,
            innerHeight = _window.innerHeight,
            document = _window.document;
        var percentage = 100 / (document.body.clientHeight - innerHeight) * scrollY;

        _this.setState({
          percentage: percentage
        });
      });
    };

    return _this;
  }

  var _proto = ProgressBar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('scroll', this.updatePercentage);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.updatePercentage);
  };

  _proto.render = function render() {
    return React.createElement(ProgressBarRoot, null, React.createElement("div", {
      className: "inner",
      style: {
        width: this.state.percentage + "%"
      }
    }));
  };

  return ProgressBar;
}(Component);

export { ProgressBar as default };